import { useState } from 'react';
import { Box, Button, Typography, Stack, Alert } from '@mui/material';
import { PlusOutlined } from '@ant-design/icons';
import AdminBookAppointmentModal from '../components/AdminBookAppointmentModal';

// Dedicated offline / walk-in appointment page. It reuses the standard
// booking modal in `offlineOnly` mode — same patient + doctor + date inputs,
// but no slot selection: each booking is assigned a queue token instead.
export default function OfflineAppointment() {
  const [open, setOpen] = useState(true);
  const [lastBooked, setLastBooked] = useState(false);

  return (
    <Box sx={{ maxWidth: 720, mx: 'auto', py: 4, px: 2 }}>
      <Stack spacing={2} alignItems="flex-start">
        <Typography variant="h4" fontWeight={700}>Offline / Walk-in Appointment</Typography>
        <Typography variant="body2" color="text.secondary">
          Register a walk-in patient. The patient is given a queue token number —
          no time slot is reserved.
        </Typography>

        {lastBooked && (
          <Alert severity="success" onClose={() => setLastBooked(false)}>
            Walk-in appointment created. Open the form again to add another.
          </Alert>
        )}

        <Button variant="contained" startIcon={<PlusOutlined />} onClick={() => setOpen(true)}>
          New Walk-in Appointment
        </Button>
      </Stack>

      <AdminBookAppointmentModal
        open={open}
        offlineOnly
        onClose={() => setOpen(false)}
        onSuccess={() => { setLastBooked(true); setOpen(false); }}
      />
    </Box>
  );
}
